export const sizeXl = '3.25rem'
export const sizeLg = '3rem'
export const sizeDb = '2rem'
export const sizeMd = '1.5rem'
export const sizeRg = '1.125rem'
export const sizeSm = '.875rem'
export const sizeHl = '.5625rem'



// WEBPACK FOOTER //
// ./src/enums/sizes.js